export enum PaymentPath {
  PAYMENT_CALLBACK = 'callback',
}
